import { CASE_CLEAR_SELECTED_ARTEFACT } from './constants';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

export function clearSelectedArtefact() {
  return {
    type: CASE_CLEAR_SELECTED_ARTEFACT,
  };
}

export function useClearSelectedArtefact() {
  const dispatch = useDispatch();

  const boundAction = useCallback(() => {
    return dispatch(clearSelectedArtefact());
  }, [dispatch]);

  return {
    clearSelectedArtefact: boundAction,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_CLEAR_SELECTED_ARTEFACT:
      return {
        ...state,
        selectedArtefact: null,
        selectedArtefactPending: false,
        selectedArtefactFeedback: null,
      };

    default:
      return state;
  }
}
